import 'slick-carousel/slick/slick.min';
// import SimpleLightbox from 'simplelightbox';

function mediaResize() {
    if($(window).width() < 960) {
        $('.menu-item-has-children').addClass('mobile-list');
        if($('.menu-item-has-children').find('.caret').length !== 0) {
            $('.menu-item-has-children.mobile-list .caret').remove();
        } else {
            $('.menu-item-has-children.mobile-list').prepend('<span class="caret"></span>');
        }
    } else {
        $('.menu-item-has-children').removeClass('mobile-list');
        $('.menu-item-has-children .caret').remove();
    }
    $('.caret').on('click', this, function H() {
        $(this).parent().find('> .sub-menu')
            .toggleClass('sub-active');
    });
    // $('.sub-menu .menu-item-has-children').removeClass('mobile-list');
    // $('.sub-menu .menu-item-has-children  > a .caret').remove();
}
$(document).ready(function() {
    mediaResize();
});

$(window).on('resize', function() {
    mediaResize();
});

$(window).on('load', function H() {
    $('.main-banner').slick({
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        prevArrow: "<button type='button' class='slick-btn slick-prev'></button>",
        nextArrow: "<button type='button' class='slick-btn slick-next'></button>"

    });
});

$('.js-menu').on('click', function() {
    $('.js-menu').toggleClass('active');
    $('.header-right').toggleClass('active');
    $('body').toggleClass('hid');
});

// Comment form
jQuery.extend(jQuery.fn, {
    validate() {
        if(jQuery(this).val().length < 3) { jQuery(this).addClass('error'); return false; } jQuery(this).removeClass('error'); return true;
    },
    validateEmail() {
        let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/,
            emailToValidate = jQuery(this).val();
        if(!emailReg.test(emailToValidate) || emailToValidate === "") {
            jQuery(this).addClass('error'); return false;
        }
        jQuery(this).removeClass('error'); return true;
    }
});

jQuery(function($) {
    $('#commentform').submit(function() {
        let button = $('#submit'),
            respond = $('#respond'),
            commentlist = $('.comment-list'),
            cancelreplylink = $('#cancel-comment-reply-link');

        if($('#author').length) $('#author').validate();
        if($('#email').length) $('#email').validateEmail();
        $('#comment').validate();
        if(!button.hasClass('loadingform') && !$('#author').hasClass('error') && !$('#email').hasClass('error') && !$('#comment').hasClass('error')) {
            // ajax request
            $.ajax({
                type: 'POST',
                url: `//${window.location.host}/wp-admin/admin-ajax.php`,
                data: `${$(this).serialize()}&action=ajaxcomments`,
                beforeSend() {
                    button.addClass('loadingform').val('Loading...');
                },
                error(request, status) {
                    if(status === 500) {
                        alert('Error while adding comment');
                    } else if(status === 'timeout') {
                        alert('Error: Server doesn\'t respond.');
                    } else {
                        let wpErrorHtml = request.responseText.split("<p>"),
                            wpErrorStr = wpErrorHtml[1].split("</p>");
                        alert(wpErrorStr[0]);
                    }
                },
                success(addedCommentHTML) {
                    if(commentlist.length > 0) {
                        if(respond.parent().hasClass('comment')) {
                            if(respond.parent().children('.children').length) {
                                respond.parent().children('.children').append(addedCommentHTML);
                            } else {
                                addedCommentHTML = `<ol class="children">${addedCommentHTML}</ol>`;
                                respond.parent().append(addedCommentHTML);
                            }
                            cancelreplylink.trigger("click");
                        } else {
                            commentlist.append(addedCommentHTML);
                        }
                    } else {
                        addedCommentHTML = `<ol class="comment-list">${addedCommentHTML}</ol>`;
                        respond.before($(addedCommentHTML));
                    }
                    $('#comment').val('');
                },
                complete() {
                    button.removeClass('loadingform').val('Post Comment');
                }
            });
        }
        return false;
    });
});

